import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import TimezoneSelector from "../components/TimezoneSelector";
import { NotificationManager } from 'react-notifications';
import "react-toastify/dist/ReactToastify.css";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API || "http://localhost:5000/api/auth";

  const handleLogout = async () => {
   const token = sessionStorage.getItem("AdminAuthToken");

    try {
      await fetch(`${baseUrl}/logout`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      NotificationManager.success('Logged out successful!');
      sessionStorage.removeItem("AdminAuthToken"); 
      navigate("/"); // Redirect to login page
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  // Auto-close the mobile sidebar whenever the route changes
  useEffect(() => {
    setMobileMenu(false);
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const validateToken = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.log("No token found");
      return false;
    }

    try {
      const response = await fetch(`${baseUrl}/validate-token`, {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      return data.success; 
    } catch (error) {
      console.error("Error validating token:", error);
      return false;
    }
  };

  // Effect to check authentication and navigate accordingly
  // useEffect(() => {
  //   const checkAuth = async () => {
  //     const isValid = await validateToken();

  //     if (!isValid) {
  //       localStorage.removeItem("token"); // Remove invalid token
  //       navigate("/"); // Redirect to login
  //     } else {
  //       // Navigate to dashboard only if the user is on the login page ("/")
  //       if (location.pathname === "/") {
  //         navigate("/dashboard");
  //       }
  //     }
  //   };

  //   checkAuth();
  // }, [navigate, location.pathname]);

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/clients" className="sidebar-logo">
           <img
            src="/assets/images/BlueAsterAR.png"
            alt="site logo"
            className="light-logo"
          />
          <img
            src="/assets/images/black logo on white.png"
            alt="site logo"
            className="dark-logo"
          />
          <img
            src="/assets/images/BlueAsterAR.png"
            alt="site logo"
            className="logo-icon"
          />
          </Link>
        </div>
        <div className="sidebar-menu-area">
<ul className="sidebar-menu" id="sidebar-menu">

<li>
  <NavLink
    to="/clients"
    className={({ isActive }) =>
      isActive || location.pathname.startsWith("/portfolio")
        ? "active-page"
        : ""
    }
  >
    <Icon icon="mdi:account-group" className="menu-icon" />
    Clients
  </NavLink>
</li>

<li
  className="sidebar-menu-group-title"
  style={{
    padding: "16px 24px 6px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    color: "#94a3b8",
    pointerEvents: "none",
  }}
>
  Copper
</li>

<li>
  <NavLink
    to="/copper/summary"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:pie-chart-2-bold-duotone" className="menu-icon" />
    Summary
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/wallets"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:wallet-money-bold-duotone" className="menu-icon" />
    Wallets / Balances
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/portfolios"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:case-round-minimalistic-bold-duotone" className="menu-icon" />
    Portfolios
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/orders"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:cart-large-2-bold-duotone" className="menu-icon" />
    Orders (Buy / Sell)
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/transfers"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:transfer-horizontal-bold-duotone" className="menu-icon" />
    Transfers
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/trades"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:chart-square-bold-duotone" className="menu-icon" />
    Trades
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/currencies"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:dollar-minimalistic-bold-duotone" className="menu-icon" />
    Currencies
  </NavLink>
</li>

<li>
  <NavLink
    to="/copper/addresses"
    className={({ isActive }) => (isActive ? "active-page" : "")}
  >
    <Icon icon="solar:map-point-bold-duotone" className="menu-icon" />
    Addresses
  </NavLink>
</li>

</ul>



</div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* <ThemeToggleButton /> */}
                <TimezoneSelector />

                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src="/assets/images/user.png"
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          Admin
                        </h6>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      {/* <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="#"
                        >
                          <Icon
                            icon="solar:user-linear"
                            className="icon text-xl"
                          />{" "}
                          My Profile
                        </Link>
                      </li> */}

                      {/* <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/change-password"
                        >
                          <Icon
                            icon="icon-park-outline:help"
                            className="icon text-xl"
                          />
                          Change Password
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={handleLogout}
                          to="/"
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
          <div className="col-auto">
          <p className="mb-0">Blue Aster Capital (BSC) © {new Date().getFullYear()} - All rights reserved.</p>
         </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
